import { canSeeResourcedInternal } from '@lib/resourced-internal';
const AdminPages = () => import('@pages/admin/admin-pages/index.vue');
const AllBrandsStatistics = () => import('@pages/admin/all-brands-statistics.vue');
const ResourcedColorLibraries = () => import('@pages/admin/resourced/color-libraries.vue');
const ResourcedCompanies = () => import('@pages/admin/resourced/companies.vue');
const ResourcedUsers = () => import('@pages/admin/resourced/users.vue');
const Announcements = () => import('@pages/admin/announcements.vue');
const ArticleStatus = () => import('@pages/admin/article-status.vue');
const Brand = () => import('@pages/admin/brand.vue');
const Certificates = () => import('@pages/admin/certificates.vue');
const Channels = () => import('@pages/admin/channels/index.vue');
const ColorCodes = () => import('@pages/admin/color-codes.vue');
const ColorGroups = () => import('@pages/admin/color-groups/index.vue');
const ColorLibraries = () => import('@pages/admin/color-libraries.vue');
const ColorNumbers = () => import('@pages/admin/color-numbers.vue');
const ColorPalettes = () => import('@pages/admin/color-palettes/index.vue');
const ColorStatus = () => import('@pages/admin/color-status.vue');
const ColorTypes = () => import('@pages/admin/color-types.vue');
const ColorPaletteStatus = () => import('@pages/admin/color-palette-status.vue');
const Compliance = () => import('@/pages/admin/compliance.vue');
const ComponentAttributeTypes = () => import('@pages/admin/component-attribute-types.vue');
const ComponentNumbers = () => import('@pages/admin/component-numbers.vue');
const ComponentStatus = () => import('@pages/admin/component-status.vue');
const SupplyChain = () => import('@pages/admin/supply-chain.vue');
const ComponentTags = () => import('@pages/admin/component-tags.vue');
const ComponentTypes = () => import('@pages/admin/component-types/index.vue');
const CompositionMaterialDetailTypes = () => import('@pages/admin/composition-material-detail-types.vue');
const CompositionMaterials = () => import('@pages/admin/composition-materials.vue');
const CurrenciesAndExchangeRates = () => import('@pages/admin/currencies-exchange-rates/index.vue');
const CustomerOrders = () => import('@pages/admin/customer-orders.vue');
const CustomFields = () => import('@pages/admin/custom-fields/index.vue');
const DefaultBOMTemplates = () => import('@pages/admin/default-bom-templates/index.vue');
const BomNames = () => import('@pages/admin/bom-names.vue');
const DeliveryTerms = () => import('@pages/admin/delivery-terms.vue');
const Destinations = () => import('@pages/admin/destinations/index.vue');
const Drops = () => import('@pages/admin/drops/index.vue');
const ExcelTemplates = () => import('@pages/admin/excel-templates.vue');
const HierarchyLevels = () => import('@pages/admin/hierarchy-levels/index.vue');
const History = () => import('@pages/admin/history/index.vue');
const HierarchyNodes = () => import('@pages/admin/hierarchy-nodes/index.vue');
const Integration = () => import('@pages/admin/integration.vue');
const MchartStatus = () => import('@pages/admin/mchart-status.vue');
const MchartTags = () => import('@pages/admin/mchart-tags.vue');
const PlacementTags = () => import('@pages/admin/placement-tags.vue');
const ProductImageTags = () => import('@pages/admin/product-image-tags.vue');
const Measurements = () => import('@pages/admin/measurements.vue');
const ModeOfTransports = () => import('@pages/admin/mode-of-transports/index.vue');
const OrderStatus = () => import('@pages/admin/order-status.vue');
const OrderTags = () => import('@pages/admin/order-tags.vue');
const OrderTypes = () => import('@pages/admin/order-types.vue');
const PaymentTerms = () => import('@pages/admin/payment-terms.vue');
const Permissions = () => import('@/pages/admin/permissions/index.vue');
const ProductCategories = () => import('@pages/admin/product-categories/index.vue');
const Products = () => import('@pages/admin/products.vue');
const SampleRoundTypes = () => import('@pages/admin/sample-round-types/sample-round-types.vue');
const SampleStatus = () => import('@pages/admin/sample-status.vue');
const SavedSections = () => import('@pages/admin/saved-sections.vue');
const Seasons = () => import('@pages/admin/seasons/index.vue');
const PriceConfigs = () => import('@pages/admin/price-configuration/index.vue');
const SizeSystems = () => import('@pages/admin/size-systems.vue');
const SkuCodes = () => import('@pages/admin/sku-codes/index.vue');
const Skus = () => import('@pages/admin/skus/index.vue');
const SupplierStatus = () => import('@pages/admin/supplier-status.vue');
const SupplierNumbers = () => import('@pages/admin/supplier-numbers.vue');
const Tags = () => import('@pages/admin/tags.vue');
const Treatments = () => import('@pages/admin/treatments.vue');
const Units = () => import('@pages/admin/units.vue');
const User = () => import('@pages/admin/user.vue');
const ApiKeys = () => import('@pages/admin/api-keys.vue');
const ManageUsers = () => import('@/pages/admin/users.vue');
const ManageRoles = () => import('@/pages/admin/roles.vue');
const UserConfig = () => import('@pages/admin/user-config/index.vue');
const ArticleNumbers = () => import('@pages/admin/article-numbers.vue');
const ReservedNumbers = () => import('@pages/admin/reserved-numbers.vue');
const OnboardingChecklist = () => import('@pages/admin/onboarding-checklist/index.vue');
const Onboarding = () => import('@pages/admin/onboarding.vue');
const Statistics = () => import('@pages/admin/statistics.vue');
const TariffCodes = () => import('@pages/admin/tariff-codes/index.vue');
const Timelines = () => import('@pages/admin/timelines/index.vue');
const Vat = () => import('@pages/admin/vat/index.vue');
const OutPriceMarkupTargets = () => import('@pages/admin/out-price-markup-targets/index.vue');
const LookupTables = () => import('@pages/admin/lookup-tables/index.vue');
const Shopify = () => import('@pages/admin/shopify/index.vue');
const Desktop = () => import('@pages/admin/desktop.vue');
const Webhooks = () => import('@pages/admin/webhooks.vue');

export const groupedRoutes = {
  // What a product is: the tree it is filed under, the numbers and states it carries, and the
  // SKUs it breaks down into.
  products: [
    { path: 'products', component: Products, meta: { title: 'Products', keywords: 'article style' } },
    {
      path: 'hierarchy-nodes',
      component: HierarchyNodes,
      meta: { title: 'Hierarchy Nodes', keywords: 'category division tree' },
    },
    {
      path: 'hierarchy-levels',
      component: HierarchyLevels,
      meta: { title: 'Hierarchy Levels', keywords: 'category division tree' },
    },
    {
      path: 'product-categories',
      component: ProductCategories,
      meta: { title: 'Product Categories', keywords: 'category' },
    },
    {
      path: 'article-numbers',
      component: ArticleNumbers,
      meta: { title: 'Article Numbers', keywords: 'style number numbering sequence' },
    },
    {
      path: 'reserved-numbers',
      component: ReservedNumbers,
      meta: { title: 'Reserved Numbers', keywords: 'blocked forbidden number product article sku legacy' },
    },
    { path: 'article-status', component: ArticleStatus, meta: { title: 'Article Status', keywords: 'state workflow' } },
    { path: 'skus', component: Skus, meta: { title: 'SKUs', keywords: 'variant article' } },
    {
      path: 'sku-codes',
      component: SkuCodes,
      meta: { title: 'SKU Codes', keywords: 'ean upc gtin barcode article number variant code' },
    },
    { path: 'tags', component: Tags, meta: { title: 'Tags', keywords: 'product tag label' } },
    {
      path: 'product-image-tags',
      component: ProductImageTags,
      meta: { title: 'Product Image Tags', keywords: 'photo picture' },
    },
  ],
  // When a product is sold. Channels belongs here rather than with the integrations it is served
  // through: what a channel carries is a season's data.
  seasons: [
    { path: 'seasons', component: Seasons, meta: { title: 'Seasons', keywords: 'collection' } },
    { path: 'drops', component: Drops, meta: { title: 'Drops', keywords: 'delivery drop' } },
    { path: 'channels', component: Channels, meta: { title: 'Channels', keywords: 'sales channel' } },
    { path: 'timelines', component: Timelines, meta: { title: 'Timelines', keywords: 'critical path gate milestone' } },
  ],
  // Colours, in one place: the codes, the palettes they are picked from, and the groups above them.
  colors: [
    {
      path: 'color-numbers',
      component: ColorNumbers,
      meta: { title: 'Color Numbers', keywords: 'colour numbering sequence' },
    },
    {
      path: 'color-libraries',
      component: ColorLibraries,
      meta: { title: 'Color Libraries', keywords: 'colour pantone library book' },
    },
    { path: 'color-codes', component: ColorCodes, meta: { title: 'Color Codes', keywords: 'colour code' } },
    { path: 'color-palettes', component: ColorPalettes, meta: { title: 'Color Palettes', keywords: 'colour' } },
    { path: 'color-groups', component: ColorGroups, meta: { title: 'Color Groups', keywords: 'colour' } },
    {
      path: 'color-status',
      component: ColorStatus,
      meta: { title: 'Color Status', keywords: 'colour status draft approved archived' },
    },
    {
      path: 'color-types',
      component: ColorTypes,
      meta: { title: 'Color Types', keywords: 'colour type solid print artwork stripe' },
    },
    {
      path: 'color-palette-status',
      component: ColorPaletteStatus,
      meta: { title: 'Color Palette Status', keywords: 'colour palette status active archived' },
    },
  ],
  // How a product is measured: the size runs, the points of measure, and the charts' own states.
  measurements: [
    { path: 'size-systems', component: SizeSystems, meta: { title: 'Size Systems', keywords: 'size run size chart' } },
    {
      path: 'measurements',
      component: Measurements,
      meta: { title: 'Measurements', keywords: 'point of measure pom mchart measurement chart' },
    },
    {
      path: 'mchart-status',
      component: MchartStatus,
      meta: { title: 'M-chart Status', keywords: 'measurement chart state' },
    },
    { path: 'mchart-tags', component: MchartTags, meta: { title: 'M-chart Tags', keywords: 'measurement chart' } },
  ],
  // The bill of materials' own furniture — what a new BOM starts as, and what its parts are called.
  bom: [
    {
      path: 'default-bom-templates',
      component: DefaultBOMTemplates,
      meta: { title: 'Default Bom Templates', keywords: 'bill of materials' },
    },
    { path: 'bom-names', component: BomNames, meta: { title: 'BOM Names', keywords: 'bill of materials' } },
    {
      path: 'placement-tags',
      component: PlacementTags,
      meta: { title: 'BOM Placement Tags', keywords: 'bill of materials' },
    },
    { path: 'saved-sections', component: SavedSections, meta: { title: 'Saved Sections', keywords: 'layout section' } },
  ],
  // What a product is made of, and what those materials are described by.
  components: [
    {
      path: 'component-types',
      component: ComponentTypes,
      meta: { title: 'Component Types', keywords: 'material type' },
    },
    {
      path: 'component-numbers',
      component: ComponentNumbers,
      meta: { title: 'Component Numbers', keywords: 'numbering sequence' },
    },
    {
      path: 'component-status',
      component: ComponentStatus,
      meta: { title: 'Component Status', keywords: 'state workflow' },
    },
    { path: 'component-tags', component: ComponentTags, meta: { title: 'Component Tags', keywords: 'material tag' } },
    {
      path: 'attribute-types',
      component: ComponentAttributeTypes,
      meta: { title: 'Component attribute types', keywords: 'component attribute' },
    },
    {
      path: 'composition-materials',
      component: CompositionMaterials,
      meta: { title: 'Composition Materials', keywords: 'fabric fibre fiber content' },
    },
    {
      path: 'composition-material-detail-types',
      component: CompositionMaterialDetailTypes,
      meta: { title: 'Composition Materials Detail Types', keywords: 'fabric fibre fiber content' },
    },
    { path: 'treatments', component: Treatments, meta: { title: 'Treatments', keywords: 'finish wash' } },
  ],
  // Who makes it, what they have to prove, and what they are paid on.
  suppliers: [
    {
      path: 'supply-chain',
      component: SupplyChain,
      meta: { title: 'Supply Chain', keywords: 'traceability tier subsupplier' },
    },
    {
      path: 'supplier-numbers',
      component: SupplierNumbers,
      meta: { title: 'Supplier Numbers', keywords: 'numbering sequence vendor' },
    },
    {
      path: 'supplier-status',
      component: SupplierStatus,
      meta: { title: 'Supplier Status', keywords: 'vendor factory state' },
    },
    {
      path: 'certificates',
      component: Certificates,
      meta: { title: 'Certificates', keywords: 'certification sustainability' },
    },
    {
      path: 'compliance',
      component: Compliance,
      meta: { title: 'Compliances', keywords: 'regulation restricted substances' },
    },
    { path: 'payment-terms', component: PaymentTerms, meta: { title: 'Payment Terms', keywords: 'terms of payment' } },
  ],
  // The sampling rounds and where a sample can be in them.
  samples: [
    {
      path: 'sample-round-types',
      component: SampleRoundTypes,
      meta: { title: 'Sample Round Types', keywords: 'proto fitting salesman round' },
    },
    { path: 'sample-status', component: SampleStatus, meta: { title: 'Sample Status', keywords: 'state workflow' } },
  ],
  // Buying: the orders themselves and the terms they are placed on.
  orders: [
    { path: 'customer-orders', component: CustomerOrders, meta: { title: 'Customer Orders', keywords: 'sales order' } },
    { path: 'order-types', component: OrderTypes, meta: { title: 'Order Types', keywords: 'purchase order' } },
    {
      path: 'order-status',
      component: OrderStatus,
      meta: { title: 'Order Status', keywords: 'purchase order state workflow' },
    },
    { path: 'order-tags', component: OrderTags, meta: { title: 'Order Tags', keywords: 'purchase order' } },
    {
      path: 'delivery-terms',
      component: DeliveryTerms,
      meta: { title: 'Delivery Terms', keywords: 'incoterms shipping terms' },
    },
  ],
  // What a product costs and what it is sold for — including what customs and carriage add:
  // tariff codes for the duty they carry, and the modes of transport freight is priced by.
  prices: [
    {
      path: 'price-configs',
      component: PriceConfigs,
      meta: { title: 'Price Configurations', keywords: 'pricing cost price list' },
    },
    {
      path: 'currencies-and-exchange-rates',
      component: CurrenciesAndExchangeRates,
      meta: { title: 'Currencies and Exchange Rates', keywords: 'fx rate money' },
    },
    {
      path: 'markup-margin-targets',
      component: OutPriceMarkupTargets,
      meta: { title: 'Markup/Margin Targets', keywords: 'markup margin target price' },
    },
    { path: 'vat', component: Vat, meta: { title: 'VAT', keywords: 'tax value added tax' } },
    {
      path: 'destinations',
      component: Destinations,
      meta: { title: 'Destinations', keywords: 'market country warehouse' },
    },
    {
      path: 'tariff-codes',
      component: TariffCodes,
      meta: { title: 'Tariff Codes', keywords: 'hs code customs commodity duty' },
    },
    {
      path: 'mode-of-transports',
      component: ModeOfTransports,
      meta: { title: 'Mode of Transport', keywords: 'mot freight shipping transport air sea truck rail courier' },
    },
  ],
  // The libraries every other page draws on: fields a brand adds of its own, the tables that map
  // one value to another, and the units both are measured in.
  fields: [
    {
      path: 'custom-fields',
      component: CustomFields,
      meta: { title: 'Custom Fields', keywords: 'custom attribute property' },
    },
    {
      path: 'lookup-tables',
      component: LookupTables,
      meta: { title: 'Lookup Tables', keywords: 'mapping conversion' },
    },
    { path: 'units', component: Units, meta: { title: 'Units', keywords: 'uom unit of measure' } },
  ],
  // The brand's own setup — who it is, what its users are shown, and what this admin offers.
  brand: [
    { path: 'brand', component: Brand, meta: { title: 'Brand', keywords: 'company settings logo' } },
    {
      path: 'announcements',
      component: Announcements,
      meta: { title: 'Announcements', keywords: 'news banner message' },
    },
    {
      path: 'onboarding-checklist',
      component: OnboardingChecklist,
      meta: { title: 'Onboarding Checklist', keywords: 'getting started setup' },
    },
    {
      path: 'onboarding',
      component: Onboarding,
      meta: { title: 'Onboarding', keywords: 'meetings notes decisions schedule gantt labs' },
    },
    { path: 'admin-pages', component: AdminPages, meta: { title: 'Admin Pages', keywords: 'visibility menu' } },
    {
      path: 'user-config',
      component: UserConfig,
      meta: { title: 'User Config', keywords: 'settings preferences defaults' },
    },
    { path: 'desktop', component: Desktop, meta: { title: 'Desktop', keywords: 'resourced drive file sync electron' } },
  ],
  // People and what they may do, plus your own account.
  users: [
    {
      path: 'manage-users',
      component: ManageUsers,
      meta: { title: 'Manage Users', keywords: 'people accounts invite' },
    },
    { path: 'roles', component: ManageRoles, meta: { title: 'Roles', keywords: 'permission access' } },
    { path: 'permissions', component: Permissions, meta: { title: 'Permissions', keywords: 'access rights role' } },
    { path: 'user', component: User, meta: { title: 'User', keywords: 'profile account me' } },
  ],
  // Getting data in and out.
  integrations: [
    {
      path: 'api-keys',
      component: ApiKeys,
      meta: { title: 'API Keys', keywords: 'token integration mcp labs secret' },
    },
    { path: 'integration', component: Integration, meta: { title: 'Integration', keywords: 'api erp export' } },
    { path: 'shopify', component: Shopify, meta: { title: 'Shopify', keywords: 'ecommerce integration webshop' } },
    { path: 'webhooks', component: Webhooks, meta: { title: 'Webhooks', keywords: 'api integration events' } },
    {
      path: 'excel-templates',
      component: ExcelTemplates,
      meta: { title: 'Excel Templates', keywords: 'export import xlsx spreadsheet' },
    },
  ],
  // The two pages that only read: what the brand has, and what happened to it.
  insights: [
    { path: 'statistics', component: Statistics, meta: { title: 'Statistics', keywords: 'stats usage numbers' } },
    { path: 'history', component: History, meta: { title: 'History', keywords: 'audit log changes' } },
  ],
  // Resourced's own, across every brand: the global Admin role, on the Resourced brand.
  resourced: [
    {
      path: 'all-brands-statistics',
      component: AllBrandsStatistics,
      meta: { title: 'All Brands Statistics', keywords: 'stats usage tenants' },
    },
    {
      path: 'resourced-users',
      component: ResourcedUsers,
      meta: { title: 'Users', keywords: 'people accounts tenants all plm users password deactivate admin' },
    },
    {
      path: 'resourced-companies',
      component: ResourcedCompanies,
      meta: { title: 'Companies', keywords: 'brands suppliers tenants create brand members' },
    },
    {
      path: 'resourced-color-libraries',
      component: ResourcedColorLibraries,
      meta: { title: 'Manage Color Libraries', keywords: 'pantone books colours import global' },
    },
  ],
} as const;

// Hiding the Resourced Internal links is not enough on its own: a bookmarked or typed URL would
// still open the page, and it would then fail on every call the API refuses.
const resourcedInternalGuard = () => canSeeResourcedInternal() || { name: 'admin' };

export const adminRoutes = Object.entries(groupedRoutes)
  .flatMap(([group, routes]) =>
    routes
      .map((route) => ({
        ...route,
        meta: { ...route.meta, group },
        ...(group === 'resourced' ? { beforeEnter: resourcedInternalGuard } : {}),
      }))
      .sort((a, b) => a.meta.title.localeCompare(b.meta.title))
  )
  .map((route) => ({ ...route, name: `admin-${route.path}` }));
